/**
 * @file Loader.jsx
 * @description Provides loading state visualization and management
 *
 * @section Responsibilities
 * - Display loading states
 * - Manage loading animations
 * - Handle loading transitions
 * - Provide loading feedback
 * - Manage loading state
 * - Handle loading errors
 *
 * @section Dependencies
 * - AnimationService: Loading animations
 * - StateService: Loading state
 * - TransitionService: State transitions
 * - FeedbackService: User feedback
 *
 * @section Integration Points
 * - Animation System: Loading animations
 * - State System: Loading state
 * - Transition System: State changes
 * - Feedback System: User feedback
 *
 * @section State Management
 * - loadingState: Loading status
 * - animationState: Animation status
 * - transitionState: Transition status
 * - errorState: Error handling
 *
 * @section Events
 * - onLoadingStart: Loading initiation
 * - onLoadingEnd: Loading completion
 * - onTransition: State transition
 * - onError: Error handling
 *
 * @section Props
 * @prop {Boolean} isLoading - Loading state
 * @prop {String} loadingText - Loading message
 * @prop {Object} animationConfig - Animation settings
 * @prop {Function} onComplete - Completion callback
 */

import React, { useState } from "react";

function Loader() {
  return (
    <div className="widget-loader">
      <img src="/assets/loader.gif" alt="" />
    </div>
  );
}

export default Loader;
